<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from "@/store";
import { getOEM } from "@/api/system";
import { translateToIcon } from "./utils/icon";
import { oemFilter } from "@/utils/oem";

getOEM().then(async res => {
  res.data = oemFilter(res.data);
  const shellConst = {
    websiteName: res.data.platfromName,
    websiteName1: res.data.platfromName.slice(0, 2),
    websiteName2: res.data.platfromName.slice(2),
    recordNo: res.data.recordNumber,
    loginText: res.data.merchantTitle,
    loginText1: res.data.merchantSubTitle,
    platfromCode: res.data.platfromCode,
    websiteLogo: res.data.logPhoto,
    systemPhoto: res.data.systemPhoto,
    iconPhoto: res.data.iconPhoto,
    platfromNum: res.data.platfromNum
  };
  // 更新数据
  store.dispatch("domain/setShellConst", shellConst);
  const icon =
    res.data.iconPhoto ||
    res.data.logPhoto ||
    res.data.systemPhoto ||
    "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oem-logo/yjys-favicon.ico";
  const head = document.getElementsByTagName("head")[0];
  const linkTag = document.createElement("link");
  linkTag.id = "dynamic-style";
  const href =
    (await translateToIcon(icon)) || "https://qiying-web-static.oss-cn-hangzhou.aliyuncs.com/oem-logo/yjys-favicon.ico";
  linkTag.href = href;
  linkTag.setAttribute("rel", "icon");
  head.appendChild(linkTag);
});

store.state.user.id = localStorage.getItem("id");

export default {
  name: "App"
};
</script>

<style lang="scss">
/********************************************以下代码勿动*****************************************************/
/* 布局-横向 */
/* c:center，s:start，e:end，a:around，b:between，w:wrap */
.rx {
  display: flex;
}

.rx-c {
  display: flex;
  align-items: center;
}

.rx-cc {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.rx-sc {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

.rx-ss {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.rx-se {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-end;
}

.rx-ec {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
}

.rx-es {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: flex-start;
}

.rx-ee {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: flex-end;
}

.rx-ac {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
}

.rx-bc {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.rx-bs {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
}

.rx-be {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-end;
}

.rx-vc {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-evenly;
  align-items: center;
}

.rx-cs {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
}

.rx-wsc {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
}

.rx-wss {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-content: flex-start;
}

.rx-wbs {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-content: flex-start;
}

/* 布局-纵向 */
.cx-ss {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.cx-cc {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.cx-ce {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-end;
}

.cx-sc {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
}

.cx-cs {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}

.cx-rc {
  display: flex;
  flex-flow: column-reverse nowrap;
  justify-content: center;
  align-items: center;
}

.gap5 {
  gap: 5px;
}
.gap10 {
  gap: 10px;
}
.gap20 {
  gap: 20px;
}

/* 布局-空间 5-100 */
.ml5 {
  margin-left: 5px;
}

.ml10 {
  margin-left: 10px;
}

.ml12 {
  margin-left: 12px;
}

.ml15 {
  margin-left: 15px;
}

.ml20 {
  margin-left: 20px;
}

.ml25 {
  margin-left: 25px;
}

.ml30 {
  margin-left: 30px;
}

.ml35 {
  margin-left: 35px;
}

.ml40 {
  margin-left: 40px;
}

.ml45 {
  margin-left: 45px;
}

.ml50 {
  margin-left: 50px;
}

.ml55 {
  margin-left: 55px;
}

.ml60 {
  margin-left: 60px;
}

.ml65 {
  margin-left: 65px;
}

.ml70 {
  margin-left: 70px;
}

.ml75 {
  margin-left: 75px;
}

.ml80 {
  margin-left: 80px;
}

.ml85 {
  margin-left: 85px;
}

.ml90 {
  margin-left: 90px;
}

.ml95 {
  margin-left: 95px;
}

.ml100 {
  margin-left: 100px;
}

.mr5 {
  margin-right: 5px;
}

.mr10 {
  margin-right: 10px;
}

.mr12 {
  margin-right: 12px;
}

.mr15 {
  margin-right: 15px;
}

.mr20 {
  margin-right: 20px;
}

.mr25 {
  margin-right: 25px;
}

.mr30 {
  margin-right: 30px;
}

.mr35 {
  margin-right: 35px;
}

.mr40 {
  margin-right: 40px;
}

.mr45 {
  margin-right: 45px;
}

.mr50 {
  margin-right: 50px;
}

.mr55 {
  margin-right: 55px;
}

.mr60 {
  margin-right: 60px;
}

.mr65 {
  margin-right: 65px;
}

.mr70 {
  margin-right: 70px;
}

.mr75 {
  margin-right: 75px;
}

.mr80 {
  margin-right: 80px;
}

.mr85 {
  margin-right: 85px;
}

.mr90 {
  margin-right: 90px;
}

.mr95 {
  margin-right: 95px;
}

.mr100 {
  margin-right: 100px;
}

.mt-2 {
  margin-top: -2px;
}

.mt5 {
  margin-top: 5px;
}

.mt10 {
  margin-top: 10px;
}

.mt12 {
  margin-top: 12px;
}

.mt15 {
  margin-top: 15px;
}

.mt20 {
  margin-top: 20px;
}

.mt22 {
  margin-top: 22px;
}

.mt25 {
  margin-top: 25px;
}

.mt30 {
  margin-top: 30px;
}

.mt35 {
  margin-top: 35px;
}

.mt40 {
  margin-top: 40px;
}

.mt45 {
  margin-top: 45px;
}

.mt50 {
  margin-top: 50px;
}

.mt55 {
  margin-top: 55px;
}

.mt60 {
  margin-top: 60px;
}

.mt65 {
  margin-top: 65px;
}

.mt70 {
  margin-top: 70px;
}

.mt75 {
  margin-top: 75px;
}

.mt80 {
  margin-top: 80px;
}

.mt85 {
  margin-top: 85px;
}

.mt90 {
  margin-top: 90px;
}

.mt95 {
  margin-top: 95px;
}

.mt100 {
  margin-top: 100px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb10 {
  margin-bottom: 10px;
}

.mb12 {
  margin-bottom: 12px;
}

.mb15 {
  margin-bottom: 15px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb24 {
  margin-bottom: 24px;
}

.mb25 {
  margin-bottom: 25px;
}

.mb30 {
  margin-bottom: 30px;
}

.mb35 {
  margin-bottom: 35px;
}

.mb40 {
  margin-bottom: 40px;
}

.mb45 {
  margin-bottom: 45px;
}

.mb50 {
  margin-bottom: 50px;
}

.mb55 {
  margin-bottom: 55px;
}

.mb60 {
  margin-bottom: 60px;
}

.mb65 {
  margin-bottom: 65px;
}

.mb70 {
  margin-bottom: 70px;
}

.mb75 {
  margin-bottom: 75px;
}

.mb80 {
  margin-bottom: 80px;
}

.mb85 {
  margin-bottom: 85px;
}

.mb90 {
  margin-bottom: 90px;
}

.mb95 {
  margin-bottom: 95px;
}

.mb100 {
  margin-bottom: 100px;
}

.mb200 {
  margin-bottom: 200px;
}

/* 布局-空间 */
.pl5 {
  padding-left: 5px;
}

.pl10 {
  padding-left: 10px;
}

.pl12 {
  padding-left: 12px;
}

.pl15 {
  padding-left: 15px;
}

.pl20 {
  padding-left: 20px;
}

.pl22 {
  padding-left: 22px;
}

.pl24 {
  padding-left: 24px;
}

.pl25 {
  padding-left: 25px;
}

.pl30 {
  padding-left: 30px;
}

.pl35 {
  padding-left: 35px;
}

.pl40 {
  padding-left: 40px;
}

.pl45 {
  padding-left: 45px;
}

.pl50 {
  padding-left: 50px;
}

.pl55 {
  padding-left: 55px;
}

.pl60 {
  padding-left: 60px;
}

.pl65 {
  padding-left: 65px;
}

.pl70 {
  padding-left: 70px;
}

.pl75 {
  padding-left: 75px;
}

.pl80 {
  padding-left: 80px;
}

.pl85 {
  padding-left: 85px;
}

.pl90 {
  padding-left: 90px;
}

.pl95 {
  padding-left: 95px;
}

.pl100 {
  padding-left: 100px;
}

.pt5 {
  padding-top: 5px;
}

.pt10 {
  padding-top: 10px;
}

.pt15 {
  padding-top: 15px;
}

.pt20 {
  padding-top: 20px;
}

.pt22 {
  padding-top: 22px;
}

.pt25 {
  padding-top: 25px;
}

.pt30 {
  padding-top: 30px;
}

.pt35 {
  padding-top: 35px;
}

.pt40 {
  padding-top: 40px;
}

.pt45 {
  padding-top: 45px;
}

.pt50 {
  padding-top: 50px;
}

.pt55 {
  padding-top: 55px;
}

.pt60 {
  padding-top: 60px;
}

.pt65 {
  padding-top: 65px;
}

.pt70 {
  padding-top: 70px;
}

.pt75 {
  padding-top: 75px;
}

.pt80 {
  padding-top: 80px;
}

.pt85 {
  padding-top: 85px;
}

.pt90 {
  padding-top: 90px;
}

.pt95 {
  padding-top: 95px;
}

.pt100 {
  padding-top: 100px;
}

.pr5 {
  padding-right: 5px;
}

.pr10 {
  padding-right: 10px;
}

.pr12 {
  padding-right: 12px;
}

.pr15 {
  padding-right: 15px;
}

.pr20 {
  padding-right: 20px;
}

.pr22 {
  padding-right: 22px;
}

.pr24 {
  padding-right: 24px;
}

.pr25 {
  padding-right: 25px;
}

.pr30 {
  padding-right: 30px;
}

.pr35 {
  padding-right: 35px;
}

.pr40 {
  padding-right: 40px;
}

.pr45 {
  padding-right: 45px;
}

.pr50 {
  padding-right: 50px;
}

.pr55 {
  padding-right: 55px;
}

.pr60 {
  padding-right: 60px;
}

.pr65 {
  padding-right: 65px;
}

.pr70 {
  padding-right: 70px;
}

.pr75 {
  padding-right: 75px;
}

.pr80 {
  padding-right: 80px;
}

.pr85 {
  padding-right: 85px;
}

.pr90 {
  padding-right: 90px;
}

.pr95 {
  padding-right: 95px;
}

.pr100 {
  padding-right: 100px;
}

.pb5 {
  padding-bottom: 5px;
}

.pb10 {
  padding-bottom: 10px;
}

.pb15 {
  padding-bottom: 15px;
}

.pb20 {
  padding-bottom: 20px;
}

.pb22 {
  padding-bottom: 22px;
}

.pb25 {
  padding-bottom: 25px;
}

.pb30 {
  padding-bottom: 30px;
}

.pb35 {
  padding-bottom: 35px;
}

.pb40 {
  padding-bottom: 40px;
}

.pb45 {
  padding-bottom: 45px;
}

.pb50 {
  padding-bottom: 50px;
}

.pb55 {
  padding-bottom: 55px;
}

.pb60 {
  padding-bottom: 60px;
}

.pb65 {
  padding-bottom: 65px;
}

.pb70 {
  padding-bottom: 70px;
}

.pb75 {
  padding-bottom: 75px;
}

.pb80 {
  padding-bottom: 80px;
}

.pb85 {
  padding-bottom: 85px;
}

.pb90 {
  padding-bottom: 90px;
}

.pb95 {
  padding-bottom: 95px;
}

.pb100 {
  padding-bottom: 100px;
}

.pb200 {
  padding-bottom: 200px;
}

/* 布局-定位 */
.posi-a {
  position: absolute;
}

.posi-r {
  position: relative;
}

.posi-f {
  position: fixed;
}

/* 线条-圆角 5-100px*/
.bdr5 {
  border-radius: 5px;
}

.bdr10 {
  border-radius: 10px;
}

.bdr15 {
  border-radius: 15px;
}

.bdr20 {
  border-radius: 20px;
}

.bdr25 {
  border-radius: 25px;
}

.bdr30 {
  border-radius: 30px;
}

.bdr35 {
  border-radius: 35px;
}

.bdr40 {
  border-radius: 40px;
}

.bdr45 {
  border-radius: 45px;
}

.bdr50 {
  border-radius: 50px;
}

.bdr55 {
  border-radius: 55px;
}

.bdr60 {
  border-radius: 60px;
}

.bdr65 {
  border-radius: 65px;
}

.bdr70 {
  border-radius: 70px;
}

.bdr75 {
  border-radius: 75px;
}

.bdr80 {
  border-radius: 80px;
}

.bdr85 {
  border-radius: 85px;
}

.bdr90 {
  border-radius: 90px;
}

.bdr95 {
  border-radius: 95px;
}

.bdr100 {
  border-radius: 100px;
}

/* 字号 1-50px*/
.ft1 {
  font-size: 1px;
}

.ft2 {
  font-size: 2px;
}

.ft3 {
  font-size: 3px;
}

.ft4 {
  font-size: 4px;
}

.ft5 {
  font-size: 5px;
}

.ft6 {
  font-size: 6px;
}

.ft7 {
  font-size: 7px;
}

.ft8 {
  font-size: 8px;
}

.ft9 {
  font-size: 9px;
}

.ft10 {
  font-size: 10px;
}

.ft11 {
  font-size: 11px;
}

.ft12 {
  font-size: 12px;
}

.ft13 {
  font-size: 13px;
}

.ft14 {
  font-size: 14px;
}

.ft15 {
  font-size: 15px;
}

.ft16 {
  font-size: 16px;
}

.ft17 {
  font-size: 17px;
}

.ft18 {
  font-size: 18px;
}

.ft19 {
  font-size: 19px;
}

.ft20 {
  font-size: 20px;
}

.ft21 {
  font-size: 21px;
}

.ft22 {
  font-size: 22px;
}

.ft23 {
  font-size: 23px;
}

.ft24 {
  font-size: 24px;
}

.ft25 {
  font-size: 25px;
}

.ft26 {
  font-size: 26px;
}

.ft27 {
  font-size: 27px;
}

.ft28 {
  font-size: 28px;
}

.ft29 {
  font-size: 29px;
}

.ft30 {
  font-size: 30px;
}

.ft31 {
  font-size: 31px;
}

.ft32 {
  font-size: 32px;
}

.ft33 {
  font-size: 33px;
}

.ft34 {
  font-size: 34px;
}

.ft35 {
  font-size: 35px;
}

.ft36 {
  font-size: 36px;
}

.ft37 {
  font-size: 37px;
}

.ft38 {
  font-size: 38px;
}

.ft39 {
  font-size: 39px;
}

.ft40 {
  font-size: 40px;
}

.ft41 {
  font-size: 41px;
}

.ft42 {
  font-size: 42px;
}

.ft43 {
  font-size: 43px;
}

.ft44 {
  font-size: 44px;
}

.ft45 {
  font-size: 45px;
}

.ft46 {
  font-size: 46px;
}

.ft47 {
  font-size: 47px;
}

.ft48 {
  font-size: 48px;
}

.ft49 {
  font-size: 49px;
}

.ft50 {
  font-size: 50px;
}

.ft52 {
  font-size: 52px;
}

/* 颜色 */
.bg3 {
  background-color: #0069ff;
}

.red {
  color: red;
}

.color-333 {
  color: #333;
}

.color-666 {
  color: #666;
}

.color-999 {
  color: #999;
}

.color-fff {
  color: #fff;
}

.color-main {
  color: #00c2c4;
}

.color-0000FF {
  color: #0000ff;
}

.color-FF7A00 {
  color: #ff7a00;
}

.color-F75246 {
  color: #f75246;
}

.color-0069FF {
  color: #0069ff;
}
.color-606266 {
  color: #606266;
}

.color-03A113 {
  color: #03a113;
}
/* 尺寸 100% */
.ww100 {
  width: 100%;
}

.hh100 {
  height: 100%;
}

.wAuto {
  width: auto !important;
}

/* 尺寸 94% */
.ww94 {
  width: 94%;
}

.ww91 {
  width: 91%;
}

.ww90 {
  width: 90%;
}

.ww86 {
  width: 86%;
}

.ww80 {
  width: 80%;
}

.ww75 {
  width: 75%;
}

.ww70 {
  width: 70%;
}

.ww67 {
  width: 67%;
}

.ww65 {
  width: 65%;
}

.ww60 {
  width: 60%;
}

.ww50 {
  width: 50%;
}

.ww45 {
  width: 45%;
}

.ww47 {
  width: 47%;
}

.ww40 {
  width: 40%;
}

.ww35 {
  width: 35%;
}

.ww33 {
  width: 33%;
}

.ww31 {
  width: 31%;
}

.ww30 {
  width: 30%;
}

.ww28 {
  width: 28%;
}

.ww27 {
  width: 27%;
}

.ww26 {
  width: 26%;
}

.ww25 {
  width: 25%;
}

.ww22 {
  width: 22%;
}

.ww20 {
  width: 20%;
}

.ww18 {
  width: 18%;
}

/* 尺寸-宽 5-750 */
.w5 {
  width: 5px;
}

.w10 {
  width: 10px;
}

.w15 {
  width: 15px;
}

.w20 {
  width: 20px;
}

.w25 {
  width: 25px;
}

.w30 {
  width: 30px;
}

.w35 {
  width: 35px;
}

.w40 {
  width: 40px;
}

.w45 {
  width: 45px;
}

.w46 {
  width: 46px;
}

.w50 {
  width: 50px;
}

.w55 {
  width: 55px;
}

.w60 {
  width: 60px;
}

.w65 {
  width: 65px;
}

.w70 {
  width: 70px;
}

.w75 {
  width: 75px;
}

.w80 {
  width: 80px;
}

.w85 {
  width: 85px;
}

.w90 {
  width: 90px;
}

.w95 {
  width: 95px;
}

.w100 {
  width: 100px;
}

.w105 {
  width: 105px;
}

.w110 {
  width: 110px;
}

.w115 {
  width: 115px;
}

.w120 {
  width: 120px;
}

.w125 {
  width: 125px;
}

.w130 {
  width: 130px;
}

.w135 {
  width: 135px;
}

.w140 {
  width: 140px;
}

.w145 {
  width: 145px;
}

.w150 {
  width: 150px;
}

.w155 {
  width: 155px;
}

.w160 {
  width: 160px;
}

.w165 {
  width: 165px;
}

.w170 {
  width: 170px;
}

.w175 {
  width: 175px;
}

.w180 {
  width: 180px;
}

.w185 {
  width: 185px;
}

.w190 {
  width: 190px;
}

.w195 {
  width: 195px;
}

.w200 {
  width: 200px;
}

.w205 {
  width: 205px;
}

.w210 {
  width: 210px;
}

.w215 {
  width: 215px;
}

.w220 {
  width: 220px;
}

.w225 {
  width: 225px;
}

.w230 {
  width: 230px;
}

.w235 {
  width: 235px;
}

.w240 {
  width: 240px;
}

.w245 {
  width: 245px;
}

.w250 {
  width: 250px;
}

.w255 {
  width: 255px;
}

.w260 {
  width: 260px;
}

.w265 {
  width: 265px;
}

.w270 {
  width: 270px;
}

.w275 {
  width: 275px;
}

.w280 {
  width: 280px;
}

.w285 {
  width: 285px;
}

.w290 {
  width: 290px;
}

.w295 {
  width: 295px;
}

.w300 {
  width: 300px;
}

.w305 {
  width: 305px;
}

.w310 {
  width: 310px;
}

.w315 {
  width: 315px;
}

.w320 {
  width: 320px;
}

.w325 {
  width: 325px;
}

.w330 {
  width: 330px;
}

.w335 {
  width: 335px;
}

.w340 {
  width: 340px;
}

.w345 {
  width: 345px;
}

.w350 {
  width: 350px;
}

.w355 {
  width: 355px;
}

.w360 {
  width: 360px;
}

.w365 {
  width: 365px;
}

.w370 {
  width: 370px;
}

.w375 {
  width: 375px;
}

.w380 {
  width: 380px;
}

.w385 {
  width: 385px;
}

.w390 {
  width: 390px;
}

.w395 {
  width: 395px;
}

.w400 {
  width: 400px;
}

.w405 {
  width: 405px;
}

.w410 {
  width: 410px;
}

.w415 {
  width: 415px;
}

.w420 {
  width: 420px;
}

.w425 {
  width: 425px;
}

.w430 {
  width: 430px;
}

.w435 {
  width: 435px;
}

.w440 {
  width: 440px;
}

.w445 {
  width: 445px;
}

.w450 {
  width: 450px;
}

.w455 {
  width: 455px;
}

.w460 {
  width: 460px;
}

.w465 {
  width: 465px;
}

.w470 {
  width: 470px;
}

.w475 {
  width: 475px;
}

.w480 {
  width: 480px;
}

.w485 {
  width: 485px;
}

.w490 {
  width: 490px;
}

.w495 {
  width: 495px;
}

.w500 {
  width: 500px;
}

.w505 {
  width: 505px;
}

.w510 {
  width: 510px;
}

.w515 {
  width: 515px;
}

.w520 {
  width: 520px;
}

.w525 {
  width: 525px;
}

.w530 {
  width: 530px;
}

.w535 {
  width: 535px;
}

.w540 {
  width: 540px;
}

.w545 {
  width: 545px;
}

.w550 {
  width: 550px;
}

.w555 {
  width: 555px;
}

.w560 {
  width: 560px;
}

.w565 {
  width: 565px;
}

.w570 {
  width: 570px;
}

.w575 {
  width: 575px;
}

.w580 {
  width: 580px;
}

.w585 {
  width: 585px;
}

.w590 {
  width: 590px;
}

.w595 {
  width: 595px;
}

.w600 {
  width: 600px;
}

.w605 {
  width: 605px;
}

.w610 {
  width: 610px;
}

.w615 {
  width: 615px;
}

.w620 {
  width: 620px;
}

.w625 {
  width: 625px;
}

.w630 {
  width: 630px;
}

.w635 {
  width: 635px;
}

.w640 {
  width: 640px;
}

.w645 {
  width: 645px;
}

.w650 {
  width: 650px;
}

.w655 {
  width: 655px;
}

.w660 {
  width: 660px;
}

.w665 {
  width: 665px;
}

.w670 {
  width: 670px;
}

.w675 {
  width: 675px;
}

.w680 {
  width: 680px;
}

.w685 {
  width: 685px;
}

.w690 {
  width: 690px;
}

.w695 {
  width: 695px;
}

.w700 {
  width: 700px;
}

.w705 {
  width: 705px;
}

.w710 {
  width: 710px;
}

.w715 {
  width: 715px;
}

.w720 {
  width: 720px;
}

.w725 {
  width: 725px;
}

.w730 {
  width: 730px;
}

.w735 {
  width: 735px;
}

.w740 {
  width: 740px;
}

.w745 {
  width: 745px;
}

.w750 {
  width: 750px;
}

.w1300 {
  width: 1300px;
}

/* 尺寸-高 5-750*/
.h5 {
  height: 5px;
}

.h10 {
  height: 10px;
}

.h15 {
  height: 15px;
}

.h20 {
  height: 20px;
}

.h25 {
  height: 25px;
}

.h30 {
  height: 30px;
}

.h35 {
  height: 35px;
}

.h40 {
  height: 40px;
}

.h45 {
  height: 45px;
}

.h46 {
  height: 46px;
}

.h50 {
  height: 50px;
}

.h55 {
  height: 55px;
}

.h60 {
  height: 60px;
}

.h65 {
  height: 65px;
}

.h70 {
  height: 70px;
}

.h75 {
  height: 75px;
}

.h80 {
  height: 80px;
}

.h85 {
  height: 85px;
}

.h90 {
  height: 90px;
}

.h95 {
  height: 95px;
}

.h100 {
  height: 100px;
}

.h105 {
  height: 105px;
}

.h110 {
  height: 110px;
}

.h115 {
  height: 115px;
}

.h120 {
  height: 120px;
}

.h125 {
  height: 125px;
}

.h130 {
  height: 130px;
}

.h135 {
  height: 135px;
}

.h140 {
  height: 140px;
}

.h145 {
  height: 145px;
}

.h150 {
  height: 150px;
}

.h155 {
  height: 155px;
}

.h160 {
  height: 160px;
}

.h165 {
  height: 165px;
}

.h170 {
  height: 170px;
}

.h175 {
  height: 175px;
}

.h180 {
  height: 180px;
}

.h185 {
  height: 185px;
}

.h190 {
  height: 190px;
}

.h195 {
  height: 195px;
}

.h200 {
  height: 200px;
}

.h205 {
  height: 205px;
}

.h210 {
  height: 210px;
}

.h215 {
  height: 215px;
}

.h220 {
  height: 220px;
}

.h225 {
  height: 225px;
}

.h230 {
  height: 230px;
}

.h235 {
  height: 235px;
}

.h240 {
  height: 240px;
}

.h245 {
  height: 245px;
}

.h250 {
  height: 250px;
}

.h255 {
  height: 255px;
}

.h260 {
  height: 260px;
}

.h265 {
  height: 265px;
}

.h270 {
  height: 270px;
}

.h275 {
  height: 275px;
}

.h280 {
  height: 280px;
}

.h285 {
  height: 285px;
}

.h290 {
  height: 290px;
}

.h295 {
  height: 295px;
}

.h300 {
  height: 300px;
}

.h305 {
  height: 305px;
}

.h310 {
  height: 310px;
}

.h315 {
  height: 315px;
}

.h320 {
  height: 320px;
}

.h325 {
  height: 325px;
}

.h330 {
  height: 330px;
}

.h335 {
  height: 335px;
}

.h340 {
  height: 340px;
}

.h345 {
  height: 345px;
}

.h350 {
  height: 350px;
}

.h355 {
  height: 355px;
}

.h360 {
  height: 360px;
}

.h365 {
  height: 365px;
}

.h370 {
  height: 370px;
}

.h375 {
  height: 375px;
}

.h380 {
  height: 380px;
}

.h385 {
  height: 385px;
}

.h390 {
  height: 390px;
}

.h395 {
  height: 395px;
}

.h400 {
  height: 400px;
}

.h405 {
  height: 405px;
}

.h410 {
  height: 410px;
}

.h415 {
  height: 415px;
}

.h420 {
  height: 420px;
}

.h425 {
  height: 425px;
}

.h430 {
  height: 430px;
}

.h435 {
  height: 435px;
}

.h440 {
  height: 440px;
}

.h445 {
  height: 445px;
}

.h450 {
  height: 450px;
}

.h455 {
  height: 455px;
}

.h460 {
  height: 460px;
}

.h465 {
  height: 465px;
}

.h470 {
  height: 470px;
}

.h475 {
  height: 475px;
}

.h480 {
  height: 480px;
}

.h485 {
  height: 485px;
}

.h490 {
  height: 490px;
}

.h495 {
  height: 495px;
}

.h500 {
  height: 500px;
}

.h505 {
  height: 505px;
}

.h510 {
  height: 510px;
}

.h515 {
  height: 515px;
}

.h520 {
  height: 520px;
}

.h525 {
  height: 525px;
}

.h530 {
  height: 530px;
}

.h535 {
  height: 535px;
}

.h540 {
  height: 540px;
}

.h545 {
  height: 545px;
}

.h550 {
  height: 550px;
}

.h555 {
  height: 555px;
}

.h560 {
  height: 560px;
}

.h565 {
  height: 565px;
}

.h570 {
  height: 570px;
}

.h575 {
  height: 575px;
}

.h580 {
  height: 580px;
}

.h585 {
  height: 585px;
}

.h590 {
  height: 590px;
}

.h595 {
  height: 595px;
}

.h600 {
  height: 600px;
}

.h605 {
  height: 605px;
}

.h610 {
  height: 610px;
}

.h615 {
  height: 615px;
}

.h620 {
  height: 620px;
}

.h625 {
  height: 625px;
}

.h630 {
  height: 630px;
}

.h635 {
  height: 635px;
}

.h640 {
  height: 640px;
}

.h645 {
  height: 645px;
}

.h650 {
  height: 650px;
}

.h655 {
  height: 655px;
}

.h660 {
  height: 660px;
}

.h665 {
  height: 665px;
}

.h670 {
  height: 670px;
}

.h675 {
  height: 675px;
}

.h680 {
  height: 680px;
}

.h685 {
  height: 685px;
}

.h690 {
  height: 690px;
}

.h695 {
  height: 695px;
}

.h700 {
  height: 700px;
}

.h705 {
  height: 705px;
}

.h710 {
  height: 710px;
}

.h715 {
  height: 715px;
}

.h720 {
  height: 720px;
}

.h725 {
  height: 725px;
}

.h730 {
  height: 730px;
}

.h735 {
  height: 735px;
}

.h740 {
  height: 740px;
}

.h745 {
  height: 745px;
}

.h750 {
  height: 750px;
}

/* 透明度 */
.op10 {
  opacity: 0.1;
}

.op20 {
  opacity: 0.2;
}

.op30 {
  opacity: 0.3;
}

.op40 {
  opacity: 0.4;
}

.op50 {
  opacity: 0.5;
}

.op60 {
  opacity: 0.6;
}

.op70 {
  opacity: 0.7;
}

.op80 {
  opacity: 0.8;
}

.op90 {
  opacity: 0.9;
}

.op100 {
  opacity: 1;
}

/* 单行超出省略号显示 */
.max-len {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 加粗 */
.fwb {
  font-weight: bold;
}

/* 其他 */
.ver-middle {
  vertical-align: middle;
}

.cursor-p {
  cursor: pointer;
}

.cursor-d {
  cursor: default;
}

/* 其他 */
.ofh {
  overflow: hidden;
}

.bg1 {
  background-color: #ddd;
}

.bg2 {
  background-color: #f7f7f7;
}

.bg-fff {
  background-color: #ffffff;
}

.bg-F2F5F4 {
  background-color: #f2f5f4;
}

.bg-FFEFDC {
  background-color: #ffefdc;
}

.bg-e6f7ff {
  background-color: #e6f7ff;
}

.bdBottom {
  border-bottom: 1px solid #ebeef5;
}

.bd1-91d5ff {
  border: 1px solid #91d5ff;
}

.bd1 {
  border: 1px solid #ddd;
}

.flex1 {
  flex: 1;
}

.line-ignore {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
}

.margin0auto {
  margin: 0 auto;
}

.ta-c {
  text-align: center;
}

.ta-l {
  text-align: left;
}

.ta-r {
  text-align: right;
}

.flr {
  float: right;
}

/***********************************************以上代码勿动**************************************************/
.el-step__title.is-finish {
  font-weight: 500;
}

.el-step__head.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
}

.el-step__title.is-process {
  font-weight: 400;
  color: #c0c4cc;
}

/* .page-form-search:hover {
    box-shadow: 4px 4px 4px rgb(232 237 250)
  }
  .page-data-list:hover{
    box-shadow: 4px 4px 4px rgb(232 237 250)
  } */
.page-data-table {
  border: 1px solid #ddd;
}

.el-form--inline .el-form-item {
  margin-bottom: 11px !important;
}

.el-card__body {
  padding: 15px 15px 5px 15px !important;
}

.app-container {
  background: #f6f9fa;
}

.app-main {
  padding-top: 50px !important;
  background: #f6f9fa !important;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ellipsis-two {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.el-table__body {
  width: 100%;
  table-layout: fixed !important;
}

.el-button--primary {
  background: #0069ff;
}

.el-button--primary.is-plain {
  color: #0069ff;
  background: rgba(0, 105, 255, 0.06);
  border-color: #0069ff;
}
.el-button--primary.is-plain:hover {
  background: #0069ff;
}
.el-button--text:hover {
  color: #0069ff;
}
.el-button--text {
  color: #0069ff;
}

.el-tabs__nav-next {
  margin-right: 4px;
}

.el-tabs__nav-prev {
  margin-left: 4px;
}

.el-tabs__header {
  margin: 0;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  color: #0069ff;
  background-color: #fff;
  border-bottom: 2px solid #0069ff;
}

.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: none;
  // border-bottom: none !important;
}

.cooperation-list {
  .el-tabs__nav-wrap::after {
    background-color: #fff;
  }

  .el-tabs__active-bar {
    max-width: 24px;
    height: 4px;
    margin-left: 30px;
    border-radius: 2px;
  }
}

.el-table th {
  border: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  background: #f4f4f4 !important;
}

.el-table--medium .el-table__cell {
  padding: 10px 0;
}
.el-table__empty-text {
  display: block;
  width: 500px;
  height: 385px;
  padding-top: 260px;
  background-image: url("../src/assets/img/no-data.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 200px;
  color: #333;
  box-sizing: border-box;
}
.el-table__empty-block {
  width: 100% !important;
}
.btns {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  color: #0069ff;
  font-size: 12px;
}

.btn-export {
  background: rgba(0, 100, 255, 0.06);
  padding: 0 !important;
  border: 1px solid #0069ff;
  height: 28px;

  a {
    margin: 0;
    padding: 0.5em 2em;
    display: inline-block;
    color: #0069ff;
    font-size: 12px;
  }
}
.color-F75246 {
  color: #f75246;
}

.color-109E65 {
  color: #109e65;
}

.el-tooltip__popper {
  max-width: 50%;
}

.el-upload-list--picture-card .el-upload-list__item,
.el-upload--picture-card {
  width: 100px !important;
  height: 100px !important;
}
.el-upload-list--text {
  width: 300px !important;
}
.el-upload--picture-card {
  line-height: 108px !important;
}
</style>
